<app-header></app-header>
<div class="single-blog-posts padd-row">
  <div class="container">
      <div class="single-blog-main clearfix">
          <div class="blog-single-heading">
              <h3> {{ blogData.title }} </h3>
              <div class="date"> {{ blogData.createdAt | date:'MMMM dd, y' }}</div>
              <a *ngIf="blogData?.doctorId?.name" [routerLink]="['/doctors/detail/'+blogData?.doctorId?.uniquekey]">By {{ blogData?.doctorId?.name }}</a>
          </div>
          <div style="cursor:pointer" (click)="showImagePopup(blogData.image)" class="blog-single-img">
              <img [src]="blogData.image"> </div>
          <div class="blog-single-para">
              <p [innerHTML]="blogData.text">  </p>
              <!-- <p [innerHTML]="blogData.text">  </p>
              <p [innerHTML]="blogData.text">  </p>
              <p [innerHTML]="blogData.text">  </p>
              <p [innerHTML]="blogData.text">  </p> -->
              <!-- <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. </p>
              <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. </p>
              <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever. </p> -->
          </div>
      </div>
  </div>
</div>



<!-- <div [hidden]="!reviews.comment" *ngFor="let reviews of blogData?.reviews"  class="home_posts_box mb-0">
  <div  class="home_posts_box_heading">
    <div  class="home_rightside_user_box">
      
        <div  class="home_rightside_user_box_cnt" tabindex="0">
          <h4 > {{ reviews?.userId?.name }}</h4>
          <p [innerHTML]="parseInt(getDays(reviews.createdAt)) !=0 ? parseInt(getDays(reviews.createdAt))+' days ago' : 'Today'">  </p></div>
          </div></div>
          <div  class="home_posts_box_cnt" tabindex="0"><p > {{ reviews.comment }} </p></div>
         
       
        </div>


        <div class="home_posts_box_ftr">
          <ul>
              <li>
                  <a [routerLink]="null" [class]="review?.isLiked ? 'activeLike' : ''">
                      <img (click)="loginFirstLike(review)" src="assets/images/heart.png" alt="">
                      <span> {{ blogData?.likeCount ? blogData?.likeCount : 0 }} Likes </span>
                  </a>
              </li>
              <li><button class="form-control btn"  (click)="loginFirst()" >Post a Comment</button></li>
              </ul>
              </div>

Share Via
<share-buttons [title]="blogData.title" [image]="blogData.image" [include]="include"></share-buttons> -->



<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Image Preview</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="imageUrlArray.length>1 ? true: false"
            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>


<input type="hidden" id="add_comment_trigger" data-toggle="modal" data-target="#add-comment">
<!-- The Modal -->
<div class="modal fade" id="add-comment">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form emgergency-form">
          <h2 class="text-center"><span> Post a Comment </span></h2>
          
            <div class="row">

              <div class="col-md-12">
               
                <div class="form-group-main">
                 
                <textarea class="form-control" placeholder="Add a comment..." [(ngModel)]="comment">

                </textarea>
                <div *ngIf="errorComment" class="alert alert-danger" >Please Enter Comment</div>
                <input type="button" (click)="addComment()" class="form-control btn btn-style" value="Add Comment">
                </div>
              </div>

              
              <!-- <div class="col-md-12">
                <input *ngIf="isLoggedIn" type="submit" value="Book Now" (click)="bookAmbulance(true)"
                       class="btn-style">
                
              </div> -->
            </div>
         
        </div>
      </div>
    </div>
  </div>
</div>
